<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li><router-link to="/clients">Applications</router-link></li>
        <li><router-link v-bind:to="`/clients/${this.$route.params.client_id}`">{{ this.$store.state.client.name }}</router-link></li>
        <li><router-link v-bind:to="`/clients/${this.$route.params.client_id}/articles`">Articles</router-link></li>
        <template v-if="update == true">
          <li><router-link v-bind:to="`/clients/${this.$route.params.client_id}/articles/${this.$route.params.article_id}`">{{ this.$store.state.article.title }}</router-link></li>
          <li class="is-active"><a href="#" aria-current="page">Edit article</a></li>
        </template>
        <li v-else class="is-active"><a href="#" aria-current="page">Create a new article</a></li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-6 is-offset-3" v-on:keyup.enter="submit">
        <div class="field">
          <label class="label">Title</label>
          <div class="control">
            <input
              name="title"
              type="text"
              placeholder="New article title"
              v-model="fields.title"
              v-bind:class="{ 'input': true, 'is-danger': veeErrors.has('title') }"
              v-validate="'required|max:100'"
              data-vv-as="Article title">
          </div>
          <span v-show="veeErrors.has('title')" class="help is-danger">{{ veeErrors.first('title') }}</span>
        </div>

        <div class="field">
          <label class="label">Location</label>
          <div class="control">
            <div v-bind:class="{ 'select': true, 'is-danger': veeErrors.has('location') }">
              <select
                name="location"
                v-model="fields.location"
                v-validate="'required'"
                data-vv-as="Location">
                <option value="default">Default</option>
                <option value="slider">Slider</option>
              </select>
            </div>
          </div>
          <span v-show="veeErrors.has('location')" class="help is-danger">{{ veeErrors.first('location') }}</span>
        </div>

        <div class="field">
          <label class="label">Type</label>
          <div class="control">
            <div v-bind:class="{ 'select': true, 'is-danger': veeErrors.has('articleType') }">
              <select
                name="articleType"
                v-model="articleType"
                v-validate="'required|in:link,content'"
                data-vv-as="Article type">
                <option value="" disabled>Select article type</option>
                <option value="link">Link</option>
                <option value="content">Content</option>
              </select>
            </div>
          </div>
          <span v-show="veeErrors.has('articleType')" class="help is-danger">{{ veeErrors.first('articleType') }}</span>
        </div>

        <div class="field" v-if="articleType == 'link'">
          <label class="label">Link</label>
          <div class="control">
            <input
              name="link"
              type="text"
              placeholder="URL"
              v-model="fields.link"
              v-bind:class="{ 'input': true, 'is-danger': veeErrors.has('link') }"
              v-validate="'required|url'"
              data-vv-as="Link">
          </div>
          <span v-show="veeErrors.has('link')" class="help is-danger">{{ veeErrors.first('link') }}</span>
        </div>

        <div class="field" v-if="articleType == 'content'">
          <label class="label">Content</label>
          <div class="control">
            <textarea
              name="content"
              type="text"
              placeholder="Some content here"
              v-model="fields.content"
              v-bind:class="{ 'textarea': true, 'is-danger': veeErrors.has('content') }"
              v-validate="'required'"
              data-vv-as="Content">
            </textarea>
          </div>
          <span v-show="veeErrors.has('content')" class="help is-danger">{{ veeErrors.first('content') }}</span>
        </div>

        <div class="field">
          <label class="label">Cover</label>
          <div class="file">
            <label class="file-label">
              <input
                name="file1"
                type="file"
                v-on:change="onFileChange"
                v-bind:class="{ 'file-input': true, 'is-danger': veeErrors.has('file1') }"
                v-validate="{ required: !fields.cover, image: true, ext: 'jpg' }"
                data-vv-as="Cover file">
              <span class="file-cta">
                <span class="file-icon"><i class="fa fa-upload"></i></span>
                <span class="file-label">{{ filename }}</span>
              </span>
            </label>
          </div>
          <p class="help">Must be an image file with .jpg extension.</p>
          <span v-show="veeErrors.has('file1')" class="help is-danger">{{ veeErrors.first('file1') }}</span>
        </div>

        <div class="field is-grouped">
          <div class="control">
            <button v-bind:class="{ 'button': true, 'is-primary': true, 'is-loading': isLoading }" v-on:click="submit">Submit</button>
          </div>
          <div class="control">
            <router-link v-bind:to="cancelUrl" class="button" exact>Cancel</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        fields: {
          title: '',
          location: 'default',
          link: null,
          content: null,
          cover: ''
        },
        articleType: '',
        formData: null,
        filename: 'Choose a cover image ...',
        isLoading: false
      }
    },

    computed: {
      cancelUrl () {
        return this.update ? `/clients/${this.$route.params.client_id}/articles/${this.$route.params.article_id}` : `/clients/${this.$route.params.client_id}/articles`
      }
    },

    methods: {
      onFileChange (e) {
        this.formData = new window.FormData()
        this.formData.append('file1', e.target.files[0])
        this.filename = e.target.files[0].name
      },

      submit () {
        this.$validator.validateAll().then((passed) => {
          if (!passed) {
            return
          }

          this.isLoading = true

          this.uploadFile(this.formData)
            .then(() => {
              // If a file was just uploaded use it
              this.fields.cover = this.$store.state.file.file1.filename || this.fields.cover

              return this.createOrUpdateArticle(
                this.articleType,
                this.$route.params.article_id,
                this.$route.params.client_id,
                this.fields
              )
            })
            .then(() => {
              this.$router.push(`/clients/${this.$route.params.client_id}/articles/${this.$store.state.article.id}`)
            })
            .catch(() => {
              // Add server errors into the existing ErrorBag object
              if (this.$store.state.error.response) {
                Object.keys(this.$store.state.error.response.data.error.validation_errors).forEach(key => {
                  this.veeErrors.add(key, this.$store.state.error.response.data.error.validation_errors[key][0])
                })
              }

              this.isLoading = false
            })
        })
      },

      /**
       * Upload a new cover file or skip
       * @param  {FormData} data
       * @return {Promise}
       */
      uploadFile (data) {
        if (!data) {
          return new Promise((resolve, reject) => {
            resolve()
          })
        }

        return this.$store.dispatch('uploadFile', data)
      },

      /**
       * Prepare and send fields to the API server
       * in order to create a new article or update an existing one
       * @param  {string} articleType Link or content
       * @param  {int}    articleId
       * @param  {int}    clientId
       * @param  {object} params
       * @return {Promise}
       */
      createOrUpdateArticle (articleType, articleId, clientId, params) {
        if (articleType === 'content') {
          delete params.link
        } else if (articleType === 'link') {
          delete params.content
        }

        if (articleId) {
          return this.$store.dispatch('updateArticle', { articleId, params })
        }

        params.client_id = clientId

        return this.$store.dispatch('createArticle', params)
      }
    },

    created () {
      this.$store.dispatch('getClient', {
        clientId: this.$route.params.client_id
      })

      if (this.update) {
        this.$store.dispatch('getArticle', {
          articleId: this.$route.params.article_id
        })
          .then(() => {
            this.fields = {
              title: this.$store.state.article.title,
              location: this.$store.state.article.location,
              link: this.$store.state.article.link,
              content: this.$store.state.article.content,
              cover: this.$store.state.article.cover
            }

            this.articleType = this.$store.state.article.link ? 'link' : 'content'
          })
      }
    },

    props: ['update']
  }
</script>



// WEBPACK FOOTER //
// ArticleForm.vue?2c4beaa6